export class AutofillRule {

    constructor(
        public ruleId: string,
        public type: string,
        public name: string,
        public value: string,
        public site: string,
        public mode: number,
        public profile: string
    ){}
}
